<template>
    <section class="error-page">
        <main>
            <icon name="error-helmet" alt="Error" extension="png" directory="illustrations" />

            <h1 class="center">
                {{ title }}
            </h1>

            <translate keypath="widget.errors.generic.description" tag="p" class="text center error-page__explanation" />
        </main>

        <footer>
            <call-to-action @clicked="reload">
                {{ t('widget.errors.generic.proposed-solution.reload') }}
            </call-to-action>
        </footer>
    </section>
</template>

<script lang="ts" setup>
import { Translate } from '@btcdirect/components';
import { useTranslations } from '@btcdirect/composables';
import { EmitEvents } from '@btcdirect/shared/src/components/types';
import CallToAction from '../call-to-action/call-to-action.vue';
import Icon from '../icons/icon.vue';

// TODO: Move this to a "views" directory

defineProps({
    title: {
        type: String,
        required: true,
        default: false
    }
});

defineEmits([EmitEvents.BACK]);

const { t } = useTranslations();

const reload = () => {
    window.location.reload();
};
</script>

<style lang="scss" scoped>
@use '@@scss/flex';
@use '@@scss/fonts';
@use '@@scss/variables';

.error-page {
    padding-bottom: 1em;

    main {
        @include flex.flex(flex, column);
        max-width: 380px;
        margin-left: auto;
        margin-right: auto;
    }

    .icon {
        align-self: center;
        margin-top: 4em;
        width: 9.75em;
    }

    h1 {
        margin-bottom: 0.5em;
        color: var(--text-color);
    }

    p {
        margin-bottom: 0.5em;
    }

    .error-page__explanation {
        margin-bottom: 1em;

        a:not(.btcdirect-button) {
            @include fonts.gt-walsheim-medium;
            color: #5c7990 !important;
        }
    }

    .btcdirect-button {
        width: unset;
        margin: auto auto 1em auto;
        padding: 0 1rem;
    }
}
</style>
